import React from "react";
import styles from "./BandeauEssai.module.css";

/**
 * Bandeau d'essai : une ligne fine sous le titre d'un tableau de bord pendant un essai Premium
 * (date de fin, jour en cours, ce qui reste ensuite) et un lien texte. Ce n'est pas un second
 * appel à payer : pas de bouton, pas de compte à rebours rouge.
 */
export type BandeauEssaiProps = {
  texte: string;
  lien: { href: string; label: string };
  /** Lien interne de l'application (react-router) ; à défaut, un <a> classique. */
  renderLien?: (href: string, label: string, className: string) => React.ReactNode;
};

export function BandeauEssai({ texte, lien, renderLien }: BandeauEssaiProps) {
  return (
    <p className={styles.bandeau}>
      <span className={styles.etiquette}>Premium</span>
      <span>{texte}</span>
      {renderLien ? renderLien(lien.href, lien.label, styles.lien) : <a className={styles.lien} href={lien.href}>{lien.label}</a>}
    </p>
  );
}
